import React, { useEffect, useState } from "react";
import { Button, InputGroup, Modal, Spinner } from "react-bootstrap";
import * as XLSX from "xlsx";
import { CreateAgendaShiftApplicationByUserIdMutation, CreateAgendaShiftApplicationByUserIdMutationVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from "../../graphql/API";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { getAgendaUser, usersByComId, createAgendaShiftApplicationByUserId } from "./queries";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext";
import { v4 as uuidv4 } from 'uuid';
import CustomModal from "../../components/Modals/CustomModal";
import { useTranslation } from "react-i18next";
import FileUpload from "../services/FileUpload";
import Sidebar from "../services/Sidebar/Sidebar";
import { PUBLIC_ID } from "../../config";
import TopicNotificationService from '../services/TopicService';

const generateCustomId = () => {
    const prefix = "ShiftApp";
    const uniquePart = uuidv4();
    return `${prefix}-${uniquePart}`;
};

const createShiftObject = (row: any[], index: number) => {
  return {
     // shiftId: `shift-${index + 1}`, // Générer un ID unique
    //  userId: row[0], // Supposons que la 1ère colonne = userId
    //  username: row[1],
     role: row[0], // 2ème colonne = rôle
     info: row[1], // 3ème colonne = info
     location: row[2], // 4ème colonne = lieu
     startAt: row[3], //new Date(row[5]).toISOString(), // 5ème colonne = date de début
     stopAt: row[4], //new Date(row[6]).toISOString(), // 6ème colonne = date de fin
     lat: row[5] || "",
     lng: row[6] || "",
    //  confirmed: row[6] === "true", // 7ème colonne = confirmé (booléen)
  };
};

const ExcelFileUploadShift = () => {
  const { t } = useTranslation();
  const [shifts, setShifts] = useState<any[]>([]);
  const navigate = useNavigate();
  const {userId: AuthUserId} = useAuthContext();
  
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);

  const {sendTopicNotification} = TopicNotificationService();

  const {data: dataUser, loading, error, refetch, fetchMore} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
    {variables: {userId: AuthUserId}});

  const [fetchDataUsers, {data: dataUsers, loading: loadingUsers, error: errorUsers, 
    refetch: refetchUsers, fetchMore: fetchMoreUsers}] = useLazyQuery
    <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);

  const [doCreateShift, {data: dataShiftCreate, loading: loadingShiftCreate, 
    error: eorrorShiftCreate}] = useMutation
    <CreateAgendaShiftApplicationByUserIdMutation, CreateAgendaShiftApplicationByUserIdMutationVariables>(createAgendaShiftApplicationByUserId);

  const user = dataUser?.getAgendaUser;

  useEffect(() => {
    document.title = t('title.spreadsheet');
  }, []);

  useEffect(() => {
    if (dataUser && !loading) {
        const usr = dataUser?.getAgendaUser;
        if (usr?.comId) {
            fetchDataUsers({variables: {
                comId: usr?.comId,
                filter: { 
                //   stopAt: {lt: tomorrow},
                //   confirmed: {eq: true},
                suspended: {eq: false},
                //   deleted: {ne: true}
                }
            }});
        }
    }
  }, [dataUser]);

  const users = dataUsers?.usersByComId?.items;

  if (loading) {
    return (
        <div className="spinnerContainer">
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const userIdValidation = (id: string) => {
    const user = users.find(user => user.userId === id);
    if (user) {
        return true
    }
  };

  const isValidCustomDateFormat = (dateString: string): boolean => {
    // ISO 8601 (YYYY-MM-DDTHH:mm:ss.sssZ)
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    return isoRegex.test(dateString);

    // ISO 8601 (YYYY-MM-DDTHH:mm:ss.sssZ)
    const date = new Date(dateString);
    return !isNaN(date.getTime()) && date.toISOString() === dateString;

    // "YYYY-MM-DD HH:mm:ss"
    const dateRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    return dateRegex.test(dateString);
  };

  const buildModal = (title: string, content: string) => {
    setContentModal(<>
        <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      
        <Modal.Body>
            <p>{content}</p>
        </Modal.Body>
    </>);
    setShowCustomModal(true);
  }

  const buildShift = async (shift: any) => {
    try{
        const shiftId = generateCustomId();
        await doCreateShift({variables: {
            shiftAppId: shiftId,
            userId: PUBLIC_ID,
            comId: user.comId,
            role: shift.role,
            info: shift.info,
            location: shift.location,
            username: "PUBLIC",
            lat: shift.lat,
            lng: shift.lng,
            startAt: new Date(shift.startAt).toISOString(),
            stopAt: new Date(shift.stopAt).toISOString(),
            // quality: "0",
            // performance: "0",
            // punctuality: "0",
            // rate: "0",
            deleted: false,
            accepted: false,
            suspended: false,
            confirmed: false,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
        }});
        sendTopicNotification(shift.role ?? undefined, shift.location ?? undefined, undefined, PUBLIC_ID, shiftId ?? undefined, shift.startAt, shift.stopAt, "openShift", `${user.comId}_posts`, true);
    } catch (error) {
        console.log('error', (error as Error).message);
    }
  };

  const tableValidation = (shifts: any[]) => {
    for (const shift of shifts) {
        if (!shift.role || !shift.info || !shift.location || !shift.startAt || !shift.stopAt) {
            buildModal("Missing value", "A cell is empty, verify the fields.");
            return false;
        }
        // if (!userIdValidation(shift.userId)) {
        //     buildModal("Invalid worker", "This worker ID is not valid: " + shift.userId);
        //     return false;
        // }
        if (!isValidCustomDateFormat(shift.startAt)) {
            buildModal("Invalid Date Format", "This job starting date is not valid: " + shift.startAt);
            return false;
        }
        if (!isValidCustomDateFormat(shift.stopAt)) {
            buildModal("Invalid Date Format", "This job stoping date is not valid: " + shift.stopAt);
            return false;
        }
    };
    return true;
  };

  const shiftCreation = (shifts: any[]) => {
    const valid = tableValidation(shifts);
    if (valid) {
        shifts.forEach((shift) => {
            buildShift(shift);
        });
        // BAD HACK need time to get the result
        setTimeout(() => {
          navigate(`${t('link.scheduler')}${t('link.open_shifts')}`);
        }, 1000);
    }
  };

  // Gestion de l'upload du fichier
  // const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0];
  const handleFileUpload = (file: File) => {

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target?.result;
        const workbook = XLSX.read(data, { type: "binary" });

        // On suppose que les données sont dans la première feuille du fichier
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Convertit la feuille Excel en tableau
        const rows: any[] = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        // Supposons que la première ligne est un header
        const headers = rows[0];
        const dataRows = rows.slice(1);

        // Transformer les lignes en objets shifts
        // const parsedShifts = dataRows.map((row, index) => {
        //   const shift = createShiftObject(row, index);
        //   shiftCreation(shift); // Simule la création du shift
        //   return shift;
        // });
        const parsedShifts = dataRows.map((row, index) => {
            const shift = createShiftObject(row, index);
            return shift;
        });

        setShifts(parsedShifts);
      };

      reader.readAsBinaryString(file);
    }
  };

  return (
    <>
    <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        // animation={true}
    />
    <div className="d-flex">
        <Sidebar user={user} />
        <div className="spreadsheet-container">
          <h2>{t('table.upload_excel_title')}</h2>
          <FileUpload handleFileUpload={handleFileUpload}/>
          {/* <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} /> */}
          
          { shifts.length != 0 ?
            <h3>{t('table.open_shift_create')}</h3>
          :
            <>
            <h3>{t('table.open_shift_example')}</h3>
            <h4 style={{color: 'maroon'}}>{t('table.shift_tip')}</h4>
            </>
          }
          <div className="table-responsive">
            <table border={1} style={{ marginTop: "10px", borderCollapse: "collapse" }} className="table table-striped table-bordered mt-2 tableShift">
              <thead className="theadShift">
                <tr>
                  {/* <th>Shift ID</th> */}
                  {/* <th className="trShift">ID</th>
                  <th className="trShift">Username</th> */}
                  <th className="trShift">Role</th>
                  <th className="trShift">Info</th>
                  <th className="trShift">Location</th>
                  <th className="trShift">Start</th>
                  <th className="trShift">Stop</th>
                  <th className="trShift">Latitude <strong style={{color: 'green'}}>(optional)</strong></th>
                  <th className="trShift">Longitude <strong style={{color: 'green'}}>(optional)</strong></th>
                  {/* <th className="trShift">Confirmation</th> */}
                </tr>
              </thead>
              <tbody>
                { shifts.length != 0 ?
                  <>
                      {shifts.map((shift, i) => (
                          <tr key={i}>
                          {/* <td className="tdShift">{shift.userId}</td>
                          <td className="tdShift">{shift.username}</td> */}
                          <td className="tdShift">{shift.role}</td>
                          <td className="tdShift">{shift.info}</td>
                          <td className="tdShift">{shift.location}</td>
                          <td className="tdShift">{shift.startAt}</td>
                          <td className="tdShift">{shift.stopAt}</td>
                          <td className="tdShift">{shift.lat}</td>
                          <td className="tdShift">{shift.lng}</td>
                          {/* <td className="tdShift">{shift.confirmed ? "✅" : "❌"}</td> */}
                          </tr>
                      ))}
                  </>
                  :
                  <tr>
                  {/* <td className="tdShift" >#</td>
                  <td className="tdShift">John Doe</td> */}
                  <td className="tdShift">Carpenter</td>
                  <td className="tdShift">Supervisor: 514-333-5423</td>
                  <td className="tdShift">Montreal</td>
                  <td className="tdShift">2025-02-15T10:00:00.000Z</td>
                  <td className="tdShift">2025-02-15T18:00:00.000Z</td>
                  <td className="tdShift">45.5018869</td>
                  <td className="tdShift">-73.56739189999999</td>
                  {/* <td className="tdShift">❌</td> */}
                </tr>
                }
              </tbody>
            </table>
          </div>
          { shifts.length != 0 &&
            <div className="m-4">
                <InputGroup>
                    <Button className="ms-auto" type="button" onClick={() => shiftCreation(shifts)}>Create</Button>
                </InputGroup>
            </div>
          }
          {/* { users && users.length != 0 &&
            <>
                <div style={{marginTop: 50}}>
                    <h3>{t('table.users_list')}</h3>
                    <div className="table-responsive">
                      <table border={1} style={{ marginTop: "10px", borderCollapse: "collapse" }} className="table table-striped table-bordered mt-2 tableShift">
                          <thead className="theadShift">
                          <tr>
                              <th className="trShift">ID</th>
                              <th className="trShift">Username</th>
                          </tr>
                          </thead>
                          <tbody>
                              {users.map((usr, i) => (
                                  <tr key={i}>
                                      <td className="tdShift">{usr.userId}</td>
                                      <td className="tdShift">{usr.username}</td>
                                  </tr>
                              ))}
                          </tbody>
                      </table>
                    </div>
                </div>
            </>
          } */}
        </div>
      </div>
    </>
  );
};

export default ExcelFileUploadShift;

